const buildIconUrl = require('./build-icon-url.js');
// eslint-disable-next-line
const icons = require('./manifest.json').icons;
module.exports = {
  buildIconUrl,
  icons
};